$(document).ready(function() {
  function prepareGallery() {
    $('.media-gallery--carousel a').not('.slick-cloned').each(function() {
      const $img = $(this).find('img');
      const src = $img.attr('data-lazy') || $img.attr('data-src') || $img.attr('src');

      if (src) {
        $(this).attr({
          'data-fancybox': 'product-images',
          'data-thumb': src,
          'href': src
        });
      }
    });
  }

  prepareGallery();

  Fancybox.bind('[data-fancybox="product-images"]', {
    groupAll: false,
    Thumbs: {
      autoStart: true
    }
  });

  $(document).on('click', '.media-gallery--carousel a[data-fancybox]', function(e) {
    e.preventDefault();
    
    const items = [];
    const $validLinks = $('.media-gallery--carousel a[data-fancybox="product-images"]').not('.slick-cloned');
    
    $validLinks.each(function() {
      items.push({
        src: $(this).attr('href'),
        thumb: $(this).attr('data-thumb')
      });
    });

    const index = $validLinks.index(this);

    Fancybox.show(items, {
      startIndex: index
    });
  });
});